"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pkgManagerByTarget = void 0;
const path = require("path");
const PACKAGE_MANAGER_BY_TARGET = {
    'Gopkg.lock': 'golangdep',
    'vendor.json': 'govendor',
    'go.mod': 'gomodules',
};
function pkgManagerByTarget(targetFile) {
    const fname = path.basename(targetFile);
    return PACKAGE_MANAGER_BY_TARGET[fname];
}
exports.pkgManagerByTarget = pkgManagerByTarget;
//# sourceMappingURL=pkg-manager.js.map